<template>
  <div>
    <div v-if="isCabinet()" class="box">
      <TrainingDescriptionComponent
        v-bind:sport-types="sportTypes"
        v-bind:countries="countries"
        v-bind:cities="sortedCities"
        v-bind:language="$root.$i18n.locale"
        v-bind:current-training="currentTraining">
      </TrainingDescriptionComponent>
    </div>
    <div v-else class="box">
      <div class="row">
        <div class="col-md-6">
          <TrainingDescriptionComponent
            v-bind:sport-types="sportTypes"
            v-bind:countries="countries"
            v-bind:cities="sortedCities"
            v-bind:language="'en'"
            v-bind:current-training="currentTraining">
          </TrainingDescriptionComponent>
        </div>
        <div class="col-md-6">
          <TrainingDescriptionComponent
            v-bind:sport-types="sportTypes"
            v-bind:countries="countries"
            v-bind:cities="sortedCities"
            v-bind:language="'ru'"
            v-bind:current-training="currentTraining">
          </TrainingDescriptionComponent>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button v-on:click="saveTraining" type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
    </div>
  </div>
</template>

<script>
import TrainingDescriptionComponent from './TrainingDescription';
import axios from 'axios';

export default {
  name: 'TrainingDescriptionModal',
  template: '#select2-template',
  components: {
    TrainingDescriptionComponent
  },
  props: {
    currentTraining: Object,
    sportTypes: Array,
    countries: Array,
    cities: Array
  },
  created () {
    let self = this;

    self.$root.$on('selectCurrentTraining', function (training) {
      self.changeCountry(training.location.countryId);
    });

    self.$root.$on('changeCountry', function (countryId) {
      self.changeCountry(countryId);
    });

    self.$root.$on('saveCity', function (countryId, city) {
      self.saveCity(countryId, city);
    });
  },

  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  data () {
    return {

      newCity: {
        ru: '',
        en: ''
      }
    };
  },

  computed: {
    sortedCities: function () {
      if (!this.cities) {
        return [];
      }

      let sortedCities = this.cities;

      sortedCities.sort(function (a, b) {
        if (a.name.en < b.name.en) { return -1; }
        if (a.name.en > b.name.en) { return 1; }
        return 0;
      });
      return sortedCities;
    }
  },
  methods: {
    isCabinet: function () {
      return window.application === 'cabinet';
    },
    saveTraining: function () {
      let self = this;

      let trainingId = self.currentTraining.id;

      let q = [];

      if (self.currentTraining.qualificationAmateur) {
        q.push(1);
      }

      if (self.currentTraining.qualificationProfessional) {
        q.push(2);
      }

      let savedTraining =
          {
            'id': trainingId,
            'campId': self.currentTraining.camp.id,
            'name': self.currentTraining.name,
            'sportTypeId': self.currentTraining.sportType.id,
            'minAge': self.currentTraining.age.minAge,
            'maxAge': self.currentTraining.age.maxAge,
            'qualification': q,
            'description': self.currentTraining.description,
            'parameters': '',
            'video': self.currentTraining.video,
            'isPublish': self.currentTraining.isPublish,
            'location': {
              'countryId': self.currentTraining.location.countryId,
              'cityId': self.currentTraining.location.cityId,
              'address': self.currentTraining.location.address
            }
          };

      axios.put(
        // window.rootRoute + '/api/trainings', {training: savedTraining})
        window.host + '/sport-programs/' + trainingId, savedTraining)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    changeCountry: function (countryId) {
      let self = this;

      axios.get(
        window.host + '/countries/' + countryId + '/cities')
        .then(function (response) {
          console.log(response.data);
          self.cities = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveCity: function (countryId, city) {
      let self = this;

      console.log(city);

      var savedCity = {
        name: {
          en: city.en,
          ru: city.ru
        }
      }

      axios.post(
        window.host + '/countries/' + countryId + '/cities', savedCity)
        .then(function (response) {
          // debugger;
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');

          self.changeCountry(countryId);

          self.currentTraining.location.cityId = response.data;
        })
        .catch(function (error) {
          // debugger;
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>
